import { Component } from '@angular/core';

@Component({
  selector: 'tun-tweak-context-icon-v5',
  templateUrl: './tweak-context-icon-v5.component.html',
  styleUrls: ['./tweak-context-icon-v5.component.scss']
})
export class TweakContextIconV5Component {

}
